import gsap from 'gsap'

export default class Cursor {
  constructor(selector) {
    this.selector = selector
    this.mouse = {
      x: 0,
      y: 0
    }
    this.cursor = {
      x: 0,
      y: 0
    }
    this.lerp = 0.2
    //Methods
    !document.documentElement.classList.contains('isTouchDevice') && this.init()
  }

  init() {
    gsap.set(this.selector, { autoAlpha: 1 })
    //
    // this.big = this.selector.querySelector('.big')
    this.small = this.selector.querySelector('.small')
    this.drag = this.selector.querySelector('.drag')
    //Events
    window.addEventListener('mousemove', this.onMouseMove.bind(this))
    // Mouse effects on all links and others
    document.querySelectorAll('a').forEach(link => {
      link.addEventListener('mouseenter', this.enter.bind(this))
      link.addEventListener('mouseleave', this.leave.bind(this))
    })

  }

  

  onMouseMove(e) {
    this.mouse.x = e.x
    this.mouse.y = e.y

    // gsap.to(this.big, {
    //   x: e.x,
    //   y: e.y,
    //   delay: 0.1
    // })

    gsap.to(this.small, {
      x: e.x,
      y: e.y,
    })

    gsap.to(this.drag, {
      x: e.x - this.drag.clientWidth / 2,
      y: e.y - this.drag.clientHeight / 2,
    })
  }

  enter() {
    gsap.to(this.small, {
      scale: 2
    })
  }

  leave() {
    gsap.to(this.small, {
      scale: 1
    })
  }

}